import { VideoProtocol } from "./clock";

export class Auction {
  auctionId: number;
  auctionClusterId: number;
  name: string;
  isDeleted: boolean;
  percentageLimit: number;
  creditLimitCanBeOverruled: boolean;
  creditLimitValidationBehaviour: number;
  creditLimitAutomaticValidationOption : number;

  numberOfTransactionsStartPrice: number;
  minTransactionAmountEffectStartPrice: number;

  galleryType: string;
  gallerySize: number; 
  videoURL: string; 
  videoProtocol: VideoProtocol;
  useAdditionalSupplier: boolean;
  maxAllowedClockStopsAdditionalSupplier: number;
  additionalSupplierBuyerId: number; 

  // displayable fields:
  auctionClusterDisplayName: string;
}

export enum CreditLimitValidationBehaviour {
  MANUAL_SELECTION = 0,
  AUTOMATIC_VALIDATION = 1
}

export enum CreditLimitAutomaticValidation {
  CANCEL_AND_BLOCK = 0,
  CANCEL_ONLY = 1,
  CONFIRM_AND_BLOCK = 2,
  CONFIRM_ONLY = 3
}
